// @owners { team: patient-health }
// This is now a legacy component that will be removed in favor of ItemPricingDetailed.tsx
// when the Improved Pricing & Savings Attribution experiment is fully implemented.
import { XxsSpacing } from '@alto/design-system';
import { type PrescriptionPricing } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import { type PriceBreakdown } from '@alto/scriptdash/alto/pricing/types/v3/price_breakdown';
import React, { Fragment } from 'react';
import { PRESCRIPTION_PRICING_LABELS, PRICE_BREAKDOWN_LABELS } from '~shared/features/pricing/constants';
import { type Pricing } from '~shared/features/pricing/types';
import { formatDollarsWithPlaceholder } from '~shared/helpers/currency';
import { PricingInfoRow } from '../../pricing-info/components/PricingInfoRow';

type Props = {
  readonly pricingItem: Pricing | PrescriptionPricing;
};

export const PricingBreakdownRxLineItemsWithInsurance = ({ pricingItem }: Props) => {
  // something pricing team is working on to improve but how this currently works
  // pricingItem.prices will always be an [] length 1 or 2 if length = 2 we know the cash option
  // is better than insurance for the patient otherwise length this 1 and the only option for patient pay
  const priceBreakdownItems = pricingItem?.prices[0]?.price_breakdown;

  if (!priceBreakdownItems) {
    return null;
  }

  return (
    <>
      {/* @ts-expect-error not app paths return a value */}
      {Object.entries(priceBreakdownItems).map(([key, price], entryIndex) => {
        const priceBreakdownKey = key as keyof PriceBreakdown;
        // skip when price is $0 or key is 'total' since total is always last
        if (price !== 0 && priceBreakdownKey !== 'total') {
          return (
            <Fragment key={`${priceBreakdownKey}-${price}`}>
              {entryIndex !== 0 && <XxsSpacing />}
              <PricingInfoRow
                label={PRICE_BREAKDOWN_LABELS[priceBreakdownKey].display}
                savings={PRICE_BREAKDOWN_LABELS[priceBreakdownKey].savings}
                price={priceBreakdownItems[priceBreakdownKey]}
              />
            </Fragment>
          );
        }
      })}
      {!!Object.entries(priceBreakdownItems).length && <XxsSpacing />}
      <PricingInfoRow
        label={PRESCRIPTION_PRICING_LABELS.YOUR_COPAY}
        price={formatDollarsWithPlaceholder(priceBreakdownItems.total)}
      />
    </>
  );
};
